import Trix from "trix"
window.Trix = Trix
